import { render, staticRenderFns } from "./weaponpoolMine.vue?vue&type=template&id=5f64e1f3"
import script from "./weaponpoolMine.vue?vue&type=script&lang=js"
export * from "./weaponpoolMine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports